"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 10a.5.5 0 0 1 .354.146l3.5 3.5.064.079a.5.5 0 0 1-.693.693l-.079-.064-2.646-2.647V21.5a.5.5 0 0 1-1 0v-9.793l-2.646 2.646a.5.5 0 1 1-.708-.707l3.5-3.5A.5.5 0 0 1 12 10"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 3a5 5 0 0 1 5 5h.5a4.5 4.5 0 1 1 0 9h-3a.5.5 0 0 1 0-1h3a3.5 3.5 0 1 0 0-7h-1a.5.5 0 0 1-.5-.5V8a4 4 0 0 0-8 0v.5a.5.5 0 0 1-.5.5h-1a3.5 3.5 0 1 0 0 7h3a.5.5 0 0 1 0 1h-3a4.5 4.5 0 1 1 0-9H7a5 5 0 0 1 5-5"
  })]
}), 'SaveCloud');
